/**

Store backed by either:
 - User session data in "store" property of userContext
 OR
 - localStorage that is restricted with a timeout period (temporarySessionStore)

*/
const pubsub = require('events/pubsub');
const localStorageStore = require('./localStorageStore');
const hoursToPersist = 8;

const crossTabKeys = ['localGCAccessToken'];

// Listen to 'storage' event which is fired
// when other tabs edit local storage
window.addEventListener('storage', function (event) {
	if (event && event.key === 'sessionStore') {
		let oldValue = event.oldValue ? JSON.parse(event.oldValue) : {};
		let newValue = event.newValue ? JSON.parse(event.newValue) : {};
		let oldStore = null;
		let newStore = null;

		if (oldValue) {
			oldStore = oldValue.store;
		}

		if (newValue) {
			newStore = newValue.store;
		}

		if (oldStore && newStore) {
			crossTabKeys.forEach(k => {
				if (oldStore[k] !== newStore[k]) {
					pubsub.publish('store-changed', {
						key: k,
						value: newStore[k]
					});
				}
			});
		}
	}
});

const readStore = () => {
	let now = new Date().getTime();
	let timeout = 1000 * 60 * 60 * hoursToPersist;

	let persistentStore = localStorageStore.get('sessionStore');
	let temporarySessionStore = localStorageStore.get('temporarySessionStore');
	let sessionData = {};

	// Check if valid data in user session OR temporarySessionStore
	if (persistentStore && persistentStore.store) {
		sessionData = persistentStore.store;
	} else if (temporarySessionStore && temporarySessionStore.timeout && now - temporarySessionStore.timeout < timeout) {
		sessionData = temporarySessionStore.store;
	} else if (temporarySessionStore) {
		// No userContext and temporarySessionStore is outdated
		localStorageStore.remove('temporarySessionStore');
	}

	return sessionData;
};

const writeStore = sessionData => {
	let now = new Date().getTime();
	let persistentStore = localStorageStore.get('sessionStore');
	let temporarySessionStore = localStorageStore.get('temporarySessionStore') || { store: null };

	// Default to temporary session
	let storeKey = 'temporarySessionStore';
	let store = temporarySessionStore;

	if (persistentStore) {
		storeKey = 'sessionStore';
		store = persistentStore;
	} else {
		store.timeout = now;
	}

	store.store = sessionData;

	localStorageStore.set(storeKey, store);
};

const get = key => {
	let store = readStore();
	return key in store ? store[key] : store[key];
};

const set = (pairs, value) => {
	let store = readStore();
	let changed = [];

	if (typeof pairs === 'string') {
		var temp = pairs;

		pairs = {};

		pairs[temp] = value;
	}

	for (var k in pairs) {
		if (store[k] !== pairs[k]) {
			changed.push({
				key: k,
				value: pairs[k]
			});
		}

		store[k] = pairs[k];
	}

	// Persist
	writeStore(store);

	return changed;
};

const remove = key => {
	let store = readStore();
	let changed = key in store;

	delete store[key];

	writeStore(store);

	return changed;
};

module.exports = {
	get,
	set,
	remove
};
